
var VIEW_MY = {
    showTool: false,
    showBirth: false,
    showPi: false,
    showLun: false,
    showCompare: false,
    showReport: false,
    showFeedback: false,
    showAbout: false,
    showSet: true,
    showDonate: true
}

export {
    VIEW_MY
}